import { all, call, fork, takeEvery } from "redux-saga/effects";
// 👉 Notice 'put' is removed since we are strictly using requestFunction
import requestFunction from "../../Utils/sagaGenericFunction";
import {
  getUserWalletSuccess,
  getUserWalletFailure,
  createFundingIntentSuccess,
  createFundingIntentFailure,
  initializeFundingPaymentSuccess,
  initializeFundingPaymentFailure,
  verifyFundingPaymentSuccess,
  verifyFundingPaymentFailure,
  getWalletHistorySuccess,
  getWalletHistoryFailure,
  getAdminWalletHistorySuccess,
  getAdminWalletHistoryFailure,
  processWalletRefundSuccess,
  processWalletRefundFailure,
  processWalletRewardSuccess,
  processWalletRewardFailure,
  getCustomerWalletsSuccess,
  getCustomerWalletsFailure,
  getCashbackRulesSuccess,
  getCashbackRulesFailure,
  createCashbackRuleSuccess,
  createCashbackRuleFailure,
  updateCashbackRuleSuccess,
  updateCashbackRuleFailure,
  getRewardHistoriesSuccess,
  getRewardHistoriesFailure,
} from "../Actions/walletAction";
import {
  GET_USER_WALLET,
  CREATE_FUNDING_INTENT,
  INITIALIZE_FUNDING_PAYMENT,
  VERIFY_FUNDING_PAYMENT,
  GET_WALLET_HISTORY,
  GET_ADMIN_WALLET_HISTORY,
  PROCESS_WALLET_REFUND,
  PROCESS_WALLET_REWARD,
  GET_CUSTOMER_WALLETS,
  GET_CASHBACK_RULES,
  CREATE_CASHBACK_RULE,
  UPDATE_CASHBACK_RULE,
  GET_REWARD_HISTORIES,
} from "../ActionTypes";
import {
  GetUserWalletApi,
  CreateFundingIntentApi,
  InitializeFundingPaymentApi,
  VerifyFundingPaymentApi,
  GetWalletHistoryApi,
  GetAdminWalletHistoryApi,
  ProcessWalletRefundApi,
  ProcessWalletRewardApi,
  GetCustomerWalletsApi,
  GetCashbackRulesApi,
  CreateCashbackRuleApi,
  UpdateCashbackRuleApi,
  GetRewardHistoriesApi,
} from "../Api";

const getUserWalletWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getUserWalletSuccess,
    getUserWalletFailure,
    GetUserWalletApi,
    payload,
  );
};

const getCustomerWalletsWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getCustomerWalletsSuccess,
    getCustomerWalletsFailure,
    GetCustomerWalletsApi,
    payload,
  );
};

const getCashbackRulesWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getCashbackRulesSuccess,
    getCashbackRulesFailure,
    GetCashbackRulesApi,
    payload,
  );
};

// 👉 NOW CONSISTENT: Using requestFunction
const createCashbackRuleWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    createCashbackRuleSuccess,
    createCashbackRuleFailure,
    CreateCashbackRuleApi,
    payload,
  );
};

// 👉 NOW CONSISTENT: Using requestFunction (Passes body & payload correctly)
const updateCashbackRuleWorker = function* ({ body, payload }) {
  yield call(
    requestFunction,
    updateCashbackRuleSuccess,
    updateCashbackRuleFailure,
    UpdateCashbackRuleApi,
    body,
    payload,
  );
};

const createFundingIntentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    createFundingIntentSuccess,
    createFundingIntentFailure,
    CreateFundingIntentApi,
    payload,
  );
};

const initializeFundingPaymentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    initializeFundingPaymentSuccess,
    initializeFundingPaymentFailure,
    InitializeFundingPaymentApi,
    payload,
  );
};

const verifyFundingPaymentWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    verifyFundingPaymentSuccess,
    verifyFundingPaymentFailure,
    VerifyFundingPaymentApi,
    payload,
  );
};

const getWalletHistoryWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getWalletHistorySuccess,
    getWalletHistoryFailure,
    GetWalletHistoryApi,
    payload,
  );
};

const getAdminWalletHistoryWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getAdminWalletHistorySuccess,
    getAdminWalletHistoryFailure,
    GetAdminWalletHistoryApi,
    payload,
  );
};

const processWalletRefundWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    processWalletRefundSuccess,
    processWalletRefundFailure,
    ProcessWalletRefundApi,
    payload,
  );
};

const processWalletRewardWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    processWalletRewardSuccess,
    processWalletRewardFailure,
    ProcessWalletRewardApi,
    payload,
  );
};
const getRewardHistoriesWorker = function* ({ payload }) {
  yield call(
    requestFunction,
    getRewardHistoriesSuccess,
    getRewardHistoriesFailure,
    GetRewardHistoriesApi,
    payload,
  );
};

export const getUserWalletWatcher = function* () {
  yield takeEvery(GET_USER_WALLET, getUserWalletWorker);
};

export const fundingSagas = function* () {
  yield takeEvery(CREATE_FUNDING_INTENT, createFundingIntentWorker);
  yield takeEvery(INITIALIZE_FUNDING_PAYMENT, initializeFundingPaymentWorker);
  yield takeEvery(VERIFY_FUNDING_PAYMENT, verifyFundingPaymentWorker);
};

export const walletHistorySaga = function* () {
  yield takeEvery(GET_WALLET_HISTORY, getWalletHistoryWorker);
  yield takeEvery(GET_ADMIN_WALLET_HISTORY, getAdminWalletHistoryWorker);
};

export const walletAdminActionsSaga = function* () {
  yield takeEvery(PROCESS_WALLET_REFUND, processWalletRefundWorker);
  yield takeEvery(PROCESS_WALLET_REWARD, processWalletRewardWorker);
  yield takeEvery(GET_CUSTOMER_WALLETS, getCustomerWalletsWorker);
  yield takeEvery(GET_CASHBACK_RULES, getCashbackRulesWorker);
  yield takeEvery(CREATE_CASHBACK_RULE, createCashbackRuleWorker);
  yield takeEvery(UPDATE_CASHBACK_RULE, updateCashbackRuleWorker);
  yield takeEvery(GET_REWARD_HISTORIES, getRewardHistoriesWorker);
};

export default function* walletSaga() {
  yield all([
    fork(getUserWalletWatcher),
    fork(fundingSagas),
    fork(walletHistorySaga),
    fork(walletAdminActionsSaga),
  ]);
}
